import styled from "styled-components";

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14.4px;

  @media (max-width: 900px) {
    gap: 9.6px;
  }
`;
